import { cn } from '@/lib/utils';

const HowSafeIsYourCarHeading = ({ className }: { className?: string }) => (
  <h1 className={cn('flex justify-center text-center text-2xl', className)}>
    how
    <span className="font-normal">safe</span>
    is
    <span className="font-normal">your</span>
    car?
  </h1>
);

export default HowSafeIsYourCarHeading;
